import React, { useState, useEffect } from 'react'
import styles from "./table.styles.module.scss"
import { PreviousIcon, NextIcon } from "./icon"
import { Table } from '@tanstack/react-table'
import ReactSelect, { SingleValue } from 'react-select';
import { paginationSelectBoxStyles } from './paginationSelectBoxStyles';
interface IOption {
    value: number;
    label: string;
}
interface Props extends Table<{
    [key: string]: any;
}> {
    onChangePagination?: (pageNumber: number, pageSize: number) => void
}

function TablePagination(props: Props) {
    const { getPageOptions, nextPage,
        previousPage, getState, setPageIndex,
        getCanNextPage, getCanPreviousPage,
        onChangePagination, setPageSize } = props
    const { pagination: { pageIndex, pageSize } } = getState()
    const [rowPerPage, setRowPerPage] = useState<IOption>({ label: pageSize.toString(), value: pageSize })
    const defaultPage = {
        start: 0,
        end: 4
    }
    const [displayNumber, setDisplayNumber] = useState(defaultPage)

    useEffect(() => {
        setRowPerPage({ label: pageSize.toString(), value: pageSize })
        return () => { }
    }, [pageSize])

    useEffect(() => {
        const lastNumber = getPageOptions().at(-1) || displayNumber.end
        if (pageIndex === 0 && pageIndex <= 4) {
            setDisplayNumber(defaultPage)
        } else if (pageIndex > 4 && pageIndex < lastNumber) {
            setDisplayNumber({ ...displayNumber, start: pageIndex - 2, end: pageIndex + 2 })
        } else if (pageIndex >= 5) {
            setDisplayNumber({ ...displayNumber, start: pageIndex - 4, end: pageIndex })
        }
    }, [pageIndex])

    const onPaginationHandler = (pageNumber: number, pageSize: number) => {
        onChangePagination && onChangePagination(pageNumber, pageSize)
    }

    return (
        <div className={styles.paginationWrap}>
            <div className={styles.perPageRow}>
                <div className={styles.rowPerPageTitle}><span>Rows as per page:</span></div>
                <div>
                    <ReactSelect
                        value={rowPerPage}
                        options={[
                            { label: '5', value: 5 },
                            { label: '10', value: 10 },
                            { label: '15', value: 15 },
                            { label: '20', value: 20 }
                        ]}
                        onChange={(e: SingleValue<IOption>) => {
                            if (e) {
                                setRowPerPage(e)
                                setPageSize(e.value)
                                onPaginationHandler(1, e.value)
                            }
                        }}
                        styles={paginationSelectBoxStyles}
                        menuPlacement={'top'}
                    />
                </div>
            </div>
            <nav aria-label="Page navigation example" className={styles.paginationItem}>
                <ul className="pagination">
                    <li className="page-item">
                        <button
                            onClick={() => {
                                setPageIndex(0)
                                onPaginationHandler(1, pageSize)
                            }}
                            disabled={!getCanPreviousPage()}
                            className={` ${styles.pagelink + ' ' + styles.firstPage} page-link`} aria-label="First">
                            <PreviousIcon />
                        </button>
                    </li>
                    <li className="page-item">
                        <button
                            disabled={!getCanPreviousPage()}
                            onClick={() => {
                                previousPage()
                                setPageIndex(pageIndex - 1)
                                onPaginationHandler(pageIndex, pageSize)
                            }} className={` ${styles.pagelink} page-link`} aria-label="Previous">
                            <PreviousIcon />
                        </button>
                    </li>
                    {
                        getPageOptions().map((value) => {
                            if (value >= displayNumber.start && value <= displayNumber.end) {
                                return (
                                    <li className={`page-item ${pageIndex === value ? styles.active : ''}`} key={'page_' + (value + 1)}>
                                        <button
                                            onClick={() => {
                                                setPageIndex(value)
                                                onPaginationHandler(value + 1, pageSize)
                                            }}
                                            className={`${styles.pagelink} page-link ${styles.pageNumber}`}
                                            type="button">
                                            {value + 1}
                                        </button>
                                    </li>
                                )
                            } else {
                                return null
                            }
                        })
                    }
                    <li className="page-item">
                        <button
                            disabled={!getCanNextPage()}
                            onClick={() => {
                                nextPage()
                                setPageIndex(pageIndex + 1)
                                onPaginationHandler((pageIndex + 1) + 1, pageSize)
                            }}
                            className={`${styles.pagelink} page-link`} aria-label="Next">
                            <NextIcon />
                        </button>
                    </li>
                    <li className="page-item">
                        <button
                            disabled={!getCanNextPage()}
                            onClick={() => {
                                setPageIndex(getPageOptions().at(-1) || 0)
                                onPaginationHandler((getPageOptions().at(-1) || 0) + 1, pageSize)
                            }}
                            className={`${styles.pagelink + ' ' + styles.lastPage} page-link`}
                            aria-label="Last">
                            <NextIcon />
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default TablePagination